import { territoryAssignmentsSlice } from "./territoryAssignmentsSlice";
import * as defaultActions from "../../../../../redux/_common";
import * as constants from "./constants";
import { Dispatch } from "redux";
import { get } from "../../../../../api/requester";

export const QPARAMS_CHANGED = "territoryAssignments/QParamsChanged";
const { actions } = territoryAssignmentsSlice;
const moduleUrl = '/api/appmasterdata/territoryAssignments'

export const setValidationErrors = actions.setValidationErrors;

export const getTerritoryAssignmentTerritories = (territoryAssignmentId:string) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.setTerritoryAssignmentTerritoriesLoading(true))
    const res = await get(`${moduleUrl}/${territoryAssignmentId}/territories`);
    dispatch(actions.setTerritoryAssignmentTerritories(res));
  } catch (e) {

  } finally {
    dispatch(actions.setTerritoryAssignmentTerritoriesLoading(false))
  }
}

export const getTerritoryAssignmentUsers = (territoryAssignmentId:string) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.setTerritoryAssignmentUsersLoading(true))
    const res = await get(`${moduleUrl}/${territoryAssignmentId}/users`);
    dispatch(actions.setTerritoryAssignmentUsers(res));
  } catch (e) {

  } finally {
    dispatch(actions.setTerritoryAssignmentUsersLoading(false))
  }
}

export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );

export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);
